import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardFooter, Col, Row } from 'reactstrap';
import classNames from 'classnames';
import * as Util from "../Framework/Util";
import mapToCssModules from "map-to-css-modules";

const propTypes = {
    header: PropTypes.string,
    mainText: PropTypes.string,
    icon: PropTypes.string,
    color: PropTypes.string,
    variant: PropTypes.string,
    footer: PropTypes.bool,
    link: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    cssModule: PropTypes.object,
};

const defaultProps = {
    header: '$1,999.50',
    mainText: 'Income',
    icon: 'fa fa-cogs',
    color: 'black',
    variant: '0',
    link: '#',
};

class UserWidget extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        const { className, cssModule, header, mainText, icon, color, footer, link, children, variant, ...attributes } = this.props;

        // demo purposes only
        const padding = (variant === '0' ? { card: 'p-3', icon: 'p-3', lead: 'mt-2' } : (variant === '1' ? {
            card: 'p-0', icon: 'p-4', lead: 'pt-3',
        } : { card: 'p-0', icon: 'p-4 px-5', lead: 'pt-3' }));

        const card = { style: 'clearfix', color: color, icon: icon, classes: '' };
        card.classes = mapToCssModules(classNames(className, card.style, padding.card), cssModule);

        const lead = { style: 'h5 mb-0', color: color, classes: '' };
        lead.classes = classNames(lead.style, 'text-' + card.color, padding.lead);

        const blockIcon = function (props) {
            const classes = classNames('float-left');
            return (<img className={classes} style={{height: '40px'}} src={props.employee.imageUrl} />);
        };

        const cardFooter = function () {
            if (footer) {
                return (
                    <CardFooter className="px-3 py-2">
                        <a className="font-weight-bold font-xs btn-block text-muted" href={link}>View More
                            <i className="fa fa-angle-right float-right font-lg"></i></a>
                    </CardFooter>
                );
            }
        };

        let todayHours = Util.formatTimeFromSeconds(this.props.employee.todayHours);

        return (
            <Col lg="3" sm="12">
                <Card>
                    <CardBody className={card.classes} {...attributes}>
                        <Row>
                            <Col lg="3" sm="2" className="align-content-center align-middle">
                                <img className="img-avatar" style={{height: '40px', position: 'absolute', top: '50%', left: '65%', transform: 'translate(-50%,-50%)'}} src={this.props.employee.imageUrl} />
                            </Col>
                            <Col lg="9" sm="10">
                                <div><strong>{this.props.employee.name}</strong></div>
                                <div className="text-muted text-uppercase font-weight-bold font-xs">{this.props.employee.currentBreak ? 'ON ' + this.props.employee.currentBreak.breakType : this.props.employee.project}</div>
                                <div>{todayHours}</div>
                            </Col>
                        </Row>
                    </CardBody>
                    {cardFooter()}
                </Card>
            </Col>
        );
    }
}

UserWidget.propTypes = propTypes;
UserWidget.defaultProps = defaultProps;

export default UserWidget;
